import { BooleanTags } from "../../components/common/registerUtils";
import { createColumn, numberFormat } from "../../utils/helpers";
import { formatDateTime } from "../../utils/helpers";

export const useStatementLogs = () => {
  const tableColumns = () => [
    createColumn("partner_id", true, "Partner ID"),
    createColumn("transaction_date", true, "Transaction Date"),
    createColumn("amount", true, "Amount"),
    createColumn("transaction_type", true, "Transaction Type"),
    createColumn("partner_status", true, "Partner Status"),
    createColumn("Is_Reconciled", true, "Is Reconciled"),
    createColumn("partner_code", true, "Partner Code"),
    createColumn("account_number", true, "Account Number"),
    createColumn("description", true, "Description"),
    createColumn("charge", true, "Charge"),
  ];

  const tableData = (data: any) => {
    if (!data || !Array.isArray(data)) return [];

    return data.map((item: any) => ({
      ...item,
      amount: numberFormat(item?.amount),
      transaction_date: formatDateTime(item.transaction_date),
      Is_Reconciled: BooleanTags(item.Is_Reconciled),
    }));
  };

  return {
    tableColumns,
    tableData,
  };
};
